import { consentManagement } from './consent-management-en.i18n';

export const en = {
  consentManagement
};
